var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_33689)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_42_33689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_42_33689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 17.5V15.8333H15.8346V17.5H4.16797ZM10.0013 14.1667C8.59852 14.1667 7.50825 13.7292 6.73047 12.8542C5.95269 11.9792 5.5638 10.8194 5.5638 9.375V2.5H7.70964V9.5C7.70964 10.2778 7.90408 10.9097 8.29297 11.3958C8.68186 11.8819 9.2513 12.125 10.0013 12.125C10.7513 12.125 11.3207 11.8819 11.7096 11.3958C12.0985 10.9097 12.293 10.2778 12.293 9.5V2.5H14.4388V9.375C14.4388 10.8194 14.0499 11.9792 13.2721 12.8542C12.4944 13.7292 11.4041 14.1667 10.0013 14.1667Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_33689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.bc6f69eba4ddd43ede1d0e1eb35c54be.svg";
export { ForwardRef as ReactComponent };